(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chuck-content"]) return;
  try {
    
  (() => {
    const initializeContent = (root = document) => {
      root.querySelectorAll('[data-chuck-content]').forEach((section) => {
        if (section.dataset.chuckContentReady) return;
        section.dataset.chuckContentReady = 'true';
        const content = section.querySelector('[data-chuck-richtext]');
        const toc = section.querySelector('[data-chuck-toc]');
        const list = section.querySelector('[data-chuck-toc-list]');
        if (!content || !toc || !list) return;
        const headings = Array.from(content.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());
        if (headings.length < 3) return;
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `${section.id}-heading-${index + 1}`;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent.trim();
          item.append(link);
          list.append(item);
        });
        toc.hidden = false;
      });
    };
    initializeContent();
    document.addEventListener('shopify:section:load', (event) => initializeContent(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chuck-header"]) return;
  try {
    
  (() => {
    const normalizeRichTextEuroSpacing = (scope = document) => {
      const selector = '.chuck-native-content__richtext, .chuck-native-product__richtext, .chuck-native-policy';
      const roots = [...scope.querySelectorAll(selector)];
      if (scope.matches?.(selector)) roots.unshift(scope);
      roots.forEach((root) => {
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
          acceptNode: (node) => node.parentElement?.closest('script, style, template, noscript, code, pre, textarea, select, [contenteditable]') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
        });
        while (walker.nextNode()) {
          const node = walker.currentNode;
          if (!node.data.includes('€')) continue;
          const normalized = node.data.replace(/€[\s\u00a0\u202f]*(?=[0-9])/g, '€\u00a0');
          if (normalized !== node.data) node.data = normalized;
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => normalizeRichTextEuroSpacing(), {once: true});
    else normalizeRichTextEuroSpacing();
    document.addEventListener('shopify:section:load', (event) => normalizeRichTextEuroSpacing(event.target));
  })();
  if(!customElements.get('chuck-dutch-language')){customElements.define('chuck-dutch-language',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';try{const previous=Number(sessionStorage.getItem('chuck-language-switch')||0);if(Date.now()-previous<15000)return;sessionStorage.setItem('chuck-language-switch',String(Date.now()));this.querySelector('form')?.requestSubmit()}catch{}}})}
  if (!window.chuckComparisonMenuBound) {
    window.chuckComparisonMenuBound = true;
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const menu = event.target.closest('details.chuck-native-comparison-menu[open]') || event.target.closest('details.chuck-native-mobile-nav[open]');
      if (!menu) return;
      menu.open = false;
      menu.querySelector(':scope > summary')?.focus();
      event.preventDefault();
    });
    document.addEventListener('pointerdown', (event) => {
      document.querySelectorAll('details.chuck-native-comparison-menu[open], details.chuck-native-mobile-nav[open]').forEach((menu) => {
        if (!menu.contains(event.target)) menu.open = false;
      });
    });
    document.addEventListener('click', (event) => {
      const link = event.target.closest('.chuck-native-comparison-dropdown a');
      if (!link) return;
      const comparison = link.closest('details.chuck-native-comparison-menu');
      const mobile = link.closest('details.chuck-native-mobile-nav');
      if (comparison) comparison.open = false;
      if (mobile) mobile.open = false;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chuck-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-chuck-home]').forEach((home) => {
        if (home.dataset.initialized) return;
        const config = home.querySelector('[data-config-enhanced]');
        const form = config?.querySelector('[data-config-form]');
        const submit = config?.querySelector('[data-config-submit]');
        if (!config || !form || !submit || !window.fetch) return;
        home.dataset.initialized = 'true';
        const fallback = home.querySelector('[data-config-fallback]');
        const photo = config.querySelector('.chuck-native-home-config__photo');
        const photoLabel = config.querySelector('[data-photo-label]');
        const photoHeading = config.querySelector('[data-photo-heading]');
        const photoNote = config.querySelector('[data-photo-note]');
        const photoVisual = config.querySelector('.chuck-native-home-config__visual');
        const photoLibrary = [...config.querySelectorAll('[data-config-photo]')].map((item) => item.dataset);
        const summary = config.querySelector('[data-selection-list]');
        const total = config.querySelector('[data-config-total]');
        const error = config.querySelector('[data-config-error]');
        const cartLink = config.querySelector('[data-config-cart-link]');
        let busy = false;
        let needsCartCheck = false;
        let formatter;
        try {
          formatter = new Intl.NumberFormat(config.dataset.locale || document.documentElement.lang, { style: 'currency', currency: config.dataset.currency });
        } catch {
          return;
        }
        const choices = () => [...form.querySelectorAll('input[data-price]:checked')].filter((input) => !input.disabled && input.value !== 'none');
        const refresh = (changed) => {
          const selected = choices();
          const base = selected.find((input) => input.name === 'chuck-base');
          const value = selected.reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
          total.textContent = formatter.format(value / 100).replace(/€[\s\u00a0\u202f]*(?=[0-9])/g, '€\u00a0');
          summary.replaceChildren(...selected.map((input) => {
            const item = document.createElement('li');
            item.textContent = input.dataset.title;
            return item;
          }));
          const trolley = selected.find((input) => input.name === 'chuck-trolley');
          const ring = selected.some((input) => input.name === 'chuck-extra');
          const baseKey = base?.dataset.baseKey;
          const trolleyKey = trolley?.dataset.trolleyKey || 'none';
          const ringKey = String(ring);
          const matchedPhoto = photoLibrary.find((item) => item.base === baseKey && item.trolley === trolleyKey && item.ring === ringKey)
            || photoLibrary.find((item) => item.base === baseKey && item.trolley === trolleyKey && item.ring === 'false')
            || photoLibrary.find((item) => item.base === baseKey && item.trolley === trolleyKey)
            || photoLibrary.find((item) => item.trolley === trolleyKey && item.ring === ringKey)
            || photoLibrary.find((item) => item.trolley === trolleyKey && item.ring === 'false');
          const featured = matchedPhoto || (changed?.checked && changed?.dataset.image ? changed.dataset : base?.dataset);
          if (photo && featured?.image) {
            if (featured.srcset) photo.setAttribute('srcset', featured.srcset);
            else photo.removeAttribute('srcset');
            photo.src = featured.image;
            photo.dataset.frame = featured.frame || '';
            photo.alt = featured.label || featured.title;
            photoLabel.textContent = featured.label || featured.title;
            const notes = [];
            const exactPhoto = matchedPhoto?.base === baseKey && matchedPhoto?.trolley === trolleyKey && matchedPhoto?.ring === ringKey;
            photoHeading.textContent = exactPhoto ? photoVisual.dataset.photoExactLabel : photoVisual.dataset.photoExampleLabel;
            if (!matchedPhoto) {
              notes.push(photoVisual.dataset.photoFallbackNote);
              if (!ring && featured.imageRing === 'true') notes.push(photoVisual.dataset.photoRingOptionalNote);
              if (featured.imageBarrel === 'true') notes.push(photoVisual.dataset.photoBarrelNote);
            }
            else {
              if (matchedPhoto.base !== baseKey) notes.push(photoVisual.dataset.photoSquareNote);
              if (ring && matchedPhoto.ring === 'false') notes.push(photoVisual.dataset.photoRingNote);
              if (!ring && matchedPhoto.ring === 'true') notes.push(photoVisual.dataset.photoRingOptionalNote);
              if (matchedPhoto.barrel === 'true') notes.push(photoVisual.dataset.photoBarrelNote);
            }
            notes.push(photoVisual.dataset.photoExtrasNote);
            photoNote.textContent = notes.filter(Boolean).join(' ');
          }
          const baseInput = form.querySelector('[data-base-variant]');
          baseInput.value = base?.value || '';
          submit.disabled = busy || needsCartCheck || !base;
          submit.textContent = busy ? config.dataset.addingLabel : base ? config.dataset.addLabel : config.dataset.unavailableLabel;
          if (!needsCartCheck) error.hidden = true;
        };
        form.addEventListener('change', (event) => refresh(event.target));
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (busy || needsCartCheck) return;
          const selected = choices();
          if (!selected.some((input) => input.name === 'chuck-base')) {
            error.textContent = config.dataset.selectionLabel;
            error.hidden = false;
            error.focus();
            return;
          }
          busy = true;
          form.setAttribute('aria-busy', 'true');
          refresh();
          const fields = [...form.querySelectorAll('fieldset')];
          fields.forEach((field) => { field.disabled = true; });
          try {
            const response = await fetch(config.dataset.addUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: selected.map((input) => ({ id: input.value, quantity: 1 })) })
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : '');
            window.location.assign(config.dataset.cartUrl);
          } catch (failure) {
            needsCartCheck = true;
            error.textContent = [config.dataset.errorLabel, failure instanceof Error ? failure.message : ''].filter(Boolean).join(' ');
            error.hidden = false;
            cartLink.hidden = false;
            error.focus();
            busy = false;
            form.removeAttribute('aria-busy');
            fields.forEach((field) => { field.disabled = false; });
            refresh();
          }
        });
        refresh();
        config.hidden = false;
        if (fallback) fallback.hidden = true;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chuck-product"]) return;
  try {
    
  if (!customElements.get('chuck-native-product')) {
    customElements.define('chuck-native-product', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.media = [...this.querySelectorAll('[data-media-id]')].filter((node) => node.classList.contains('chuck-native-product__media'));
        this.thumbnails = [...this.querySelectorAll('[data-media-target]')];
        this.select = this.querySelector('[data-variant-select]');
        this.addButton = this.querySelector('[data-product-add]');
        this.quantity = this.querySelector('[data-product-quantity]');
        this.error = this.querySelector('[data-product-error]');
        const navigation = this.querySelector('.chuck-native-product__thumbnails');
        if (navigation) navigation.hidden = false;
        if (this.media.length) this.showMedia(this.dataset.selectedMedia || this.media[0].dataset.mediaId);
        this.thumbnails.forEach((button) => button.addEventListener('click', () => this.showMedia(button.dataset.mediaTarget)));
        this.select?.addEventListener('change', () => this.updateVariant());
        this.querySelector('.chuck-native-product__form')?.addEventListener('submit', (event) => this.addToCart(event));
      }
      showMedia(id) {
        if (!this.media.some((node) => node.dataset.mediaId === id)) return;
        this.media.forEach((node) => {
          node.hidden = node.dataset.mediaId !== id;
          if (node.hidden) node.querySelectorAll('video').forEach((video) => video.pause());
        });
        this.thumbnails.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === id)));
      }
      updateVariant() {
        const option = this.select.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        this.querySelector('[data-product-price]').textContent = option.dataset.price;
        this.querySelector('[data-product-compare]').hidden = !option.dataset.compare;
        this.querySelector('[data-product-compare-value]').textContent = option.dataset.compare;
        this.querySelector('[data-product-availability]').textContent = available ? this.dataset.availableLabel : this.dataset.soldLabel;
        this.addButton.disabled = !available;
        this.addButton.textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        this.quantity.min = option.dataset.min || '1';
        this.quantity.step = option.dataset.step || '1';
        if (option.dataset.max) this.quantity.max = option.dataset.max;
        else this.quantity.removeAttribute('max');
        this.quantity.value = this.quantity.min;
        const accelerated = this.querySelector('[data-product-accelerated]');
        if (accelerated) accelerated.hidden = !available;
        this.error.hidden = true;
        if (option.dataset.mediaId) this.showMedia(option.dataset.mediaId);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }
      async addToCart(event) {
        if (event.submitter !== this.addButton) return;
        if (!window.fetch) return;
        event.preventDefault();
        if (this.addButton.disabled) return;
        const form = event.currentTarget;
        const formData = new FormData(form);
        this.addButton.disabled = true;
        this.addButton.textContent = this.dataset.addingLabel;
        this.select?.setAttribute('disabled', '');
        this.error.hidden = true;
        let errorMessage = this.dataset.errorLabel;
        try {
          const response = await fetch(this.dataset.addUrl, { method: 'POST', body: formData, headers: { Accept: 'application/json' }, credentials: 'same-origin' });
          const result = await response.json();
          if (!response.ok || result.status) {
            if (typeof result.description === 'string') errorMessage = result.description;
            throw new Error(errorMessage);
          }
          window.location.assign(this.dataset.cartUrl);
        } catch {
          this.error.textContent = errorMessage;
          this.error.hidden = false;
          this.error.focus();
          this.addButton.disabled = false;
          this.addButton.textContent = this.dataset.addLabel;
          this.select?.removeAttribute('disabled');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chuck-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeReviews = (root = document) => {
      root.querySelectorAll('[data-chuck-reviews]').forEach((section) => {
        if (section.dataset.chuckReviewsReady) return;
        section.dataset.chuckReviewsReady = 'true';
        const list = section.querySelector('[data-chuck-review-list]');
        const controls = section.querySelector('[data-chuck-review-controls]');
        if (!list || !controls) return;
        const previous = controls.querySelector('[data-chuck-review-direction="-1"]');
        const next = controls.querySelector('[data-chuck-review-direction="1"]');
        const update = () => {
          const limit = list.scrollWidth - list.clientWidth;
          controls.hidden = limit < 5;
          previous.disabled = list.scrollLeft < 5;
          next.disabled = list.scrollLeft >= limit - 5;
        };
        controls.addEventListener('click', (event) => {
          const button = event.target.closest('[data-chuck-review-direction]');
          if (!button) return;
          const card = list.querySelector('li');
          const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
          const distance = card ? card.getBoundingClientRect().width + gap : list.clientWidth;
          const motion = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          list.scrollBy({left: Number(button.dataset.chuckReviewDirection) * distance, behavior: motion});
        });
        list.addEventListener('scroll', update, {passive: true});
        const observer = new ResizeObserver(update);
        observer.observe(list);
        update();
        section.addEventListener('shopify:section:unload', () => observer.disconnect(), {once: true});
      });
    };
    initializeReviews();
    document.addEventListener('shopify:section:load', (event) => initializeReviews(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chuck-videos"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('chuck-videos')){customElements.define('chuck-videos',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;this.dataset.ready='true';this.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>{document.querySelectorAll('chuck-videos video').forEach(other=>{if(other!==video)other.pause()})}))}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');          
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
              let sameCard = document.querySelector('.from-recommended');
              if(!sameCard) return;
              let cardHeight = parseInt(sameCard.clientHeight);
              let topValue = cardHeight / 2 + 5;
              let cardTopCSS = "calc(50% - "+topValue+'px)';
              let swiperContainer = document.querySelector('.product-recommendations .swiper');
              if(!swiperContainer) return;
              let swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
              let swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
              if(swiperPrevElement || swiperNextElement){
              swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
              swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);                
              }
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            this.callFunction();              
          })
          .catch(e => {
            console.log(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);      
    }
     callFunction(){     
     DTWishlist();  
   }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
